import { Component, Input } from '@angular/core';
import { ServicingFacilityPAC } from '@shared/model';

@Component({
    selector: 'servicing-facility',
    templateUrl: './servicing-facility.component.html',
    styleUrls: ['./servicing-facility.component.scss'],
    standalone: false
})
export class ServicingFacilityComponent{
  @Input() tenantName!: string;
  @Input() isInternal!: boolean;
  @Input() isGoldCardVisible = false;
  @Input() isPASComplete: boolean;

  servicingFacilityData: ServicingFacilityPAC;
  isActive: boolean;

  @Input() set servicingFacility(value: ServicingFacilityPAC) {
    this.servicingFacilityData = value;

    if (!this.servicingFacilityData.userWithoutFacilities) {
      if (this.servicingFacilityData.provider) {
        this.isActive = this.servicingFacilityData.provider.isNpiFacility;
      } else {
        this.isActive = true;
      }
    }
  };
}
